export const CSS = {
	container: 'c-LocationInput',
	label: 'c-LocationInput__label',
	tableInputs: 'c__LocationInput__tableInputs',
	error: 'c-LocationInput__error',
	isCompact: 'c-input--is-compact',
	unit: 'c-unit',
	MDL: {
		error: 'mdl-textfield__error',
	},
};

export const Style = {
	[CSS.container]: {
		width: '100%',
		display: 'block',
		'align-items': 'center',
	},
	[CSS.tableInputs]: {
		width: '100%',
		border: '0px',
	},
	[CSS.error]: {
		visibility: 'visible',
		position: 'relative',
	},
};
